import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UsuarioPerfil } from '../models/misdatos.model';

@Injectable({
  providedIn: 'root'
})
export class MisdatosService {
  private misdatosSubject = new BehaviorSubject<UsuarioPerfil | null>(null);
  misdatos$ = this.misdatosSubject.asObservable();

  constructor() { }

  setMisDatos(misdatos: UsuarioPerfil | null) {
    this.misdatosSubject.next(misdatos);
  }
  getMisDatos(): UsuarioPerfil | null {
    return this.misdatosSubject.value;
  }
}
